import React from 'react';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import HorizontalSlider from 'dpl/components/HorizontalSlider';
import SmartImage from 'dpl/components/SmartImage';
import SmartLink from 'dpl/components/SmartLink';

import { PopularBreedsResource } from '../constants/resource_types';
import { popularBreedsResourceDefinition } from '../utils/queryDefinitions';

const smartImageProps = {
  Tag: 'div' as const,
  className: 'w-100 h-100 bg-center cover',
  crop: true,
  loadingClass: 'bg-light-gray'
};

export default function PopularBreedsModule() {
  const {
    value: { data: popularBreeds }
  } = useResourceQuery<PopularBreedsResource>(
    popularBreedsResourceDefinition()
  );

  if (!popularBreeds.length) {
    return null;
  }

  return (
    <div className="PopularBreedsModule container-xxl mb8 mb20-md">
      <h5 className="font-20 md:font-24 fw-medium mb6 mb8-md">
        Popular breeds
      </h5>
      <HorizontalSlider
        containerClassName="PopularBreedsModuleSlider__container flex flex-nowrap gap-8 md:gap-24 ph6 ph0-sm"
        className="PopularBreedsModuleSlider nl6 nr6 nl0-sm nr0-sm"
        iconClassName="secondary bg-white ph2 pv2 br-100 ba b--hairline"
        iconName="fetch-chevron"
      >
        {popularBreeds.map((breed: any) => {
          const {
            availability_count_text: availabilityCountText,
            breed_overview_page_url: breedOverviewPageUrl,
            id,
            name,
            secondary_photo_url: photoUrl,
            url
          } = breed;

          return (
            <div className="flex ws-normal" key={id}>
              <div
                className="PopularBreedCard flex flex-column ba b--subtle-gray br3 overflow-hidden z-0"
                style={{ minWidth: '335px' }}
              >
                <div className="aspect-ratio aspect-ratio--1x1">
                  <div className="aspect-ratio--object">
                    <SmartImage src={photoUrl ?? ''} {...smartImageProps} />
                  </div>
                </div>
                <div className="tc pv4 ph4">
                  <p className="PopularBreedCard__breedName font-serif font-24 fw-medium">
                    {name}
                  </p>
                  {!window.__DPL_BOT_UA && availabilityCountText && (
                    <p className="font-16 secondary mt2">
                      {availabilityCountText}
                    </p>
                  )}
                </div>
                <div className="flex bt b--subtle-gray mt-auto">
                  <SmartLink
                    to={url}
                    className="font-16 fw-medium stone-700 tc pv4 ph4 flex-auto flex-basis-0"
                  >
                    View puppies
                  </SmartLink>
                  {breedOverviewPageUrl && (
                    <SmartLink
                      to={breedOverviewPageUrl}
                      className="font-16 fw-medium stone-700 tc pv4 ph4 bl b--subtle-gray flex-auto flex-basis-0"
                      target="_blank"
                    >
                      Learn about breed
                    </SmartLink>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </HorizontalSlider>
    </div>
  );
}
